import React, { useState, useEffect } from "react";
import { AdminSideMenu } from "../admin/AdminMenu";
import API_URL from "../../api/API";
import { useAdminAuthContext } from "../admin/useAdminAuthContext";

export const AdminViewAuditLogs = () => {
  const { admin } = useAdminAuthContext();

  const [viewMode, setViewMode] = useState("SESSIONS"); // LOGS | SESSIONS

  
  // Audit Logs & Pagination
  const [auditLogs, setAuditLogs] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const [searchQuery, setSearchQuery] = useState("");

  // Filters
  const [actionFilter, setActionFilter] = useState("");
  const [actorTypeFilter, setActorTypeFilter] = useState("");
  const [modelFilter, setModelFilter] = useState("");
  const [sessionIdFilter, setSessionIdFilter] = useState("");

  //Add sessions state
  const [sessions, setSessions] = useState([]);
  const [sessionPage, setSessionPage] = useState(1);
  const [totalSessionPages, setTotalSessionPages] = useState(1);

  // Expand row for detailed view
  const [expandedLogId, setExpandedLogId] = useState(null);

  // Fetch Audit Logs
  const fetchAuditLogs = async (page = 1) => {
    try {
      setIsLoading(true);
      setError("");

      const queryParams = new URLSearchParams({
        page,
        limit: 50,
        sortBy: "createdAt",
        order: "desc",
      });

      if (actionFilter) queryParams.append("action", actionFilter);
      if (actorTypeFilter) queryParams.append("actorType", actorTypeFilter);
      if (modelFilter) queryParams.append("model", modelFilter);
      if (sessionIdFilter) queryParams.append("sessionId", sessionIdFilter);


      const response = await fetch(
        `${API_URL.ADMIN_GET_AUDIT_LOGS}?${queryParams.toString()}`,
        {
            headers: {
            Authorization: `Bearer ${admin.token}`,
            "x-session-id": admin.sessionId,
            "x-frontend-url": window.location.pathname,
            },
        }
      );

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Failed to fetch audit logs");

      setAuditLogs(data.logs || []);
      setFilteredData(data.logs || []);
      setCurrentPage(data.page || 1);
      setTotalPages(data.totalPages || 1);

      setIsLoading(false);
    } catch (err) {
      setError(err.message);
      setIsLoading(false);
    }
  };

  const fetchAuditSessions = async (page = 1) => {
    try {
      setIsLoading(true);

      const queryParams = new URLSearchParams({
        page,
        limit: 50,
        sortBy: "loginAt",
        order: "desc",
      });

      const response = await fetch(
        `${API_URL.ADMIN_GET_AUDIT_SESSIONS}?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${admin.token}`,
            "x-session-id": admin.sessionId,
          },
        }
      );

      const data = await response.json();
      if (!response.ok) throw new Error(data.error);

      setSessions(data.sessions || []);
      setSessionPage(data.page);
      setTotalSessionPages(data.totalPages);

    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (viewMode === "LOGS") {
      fetchAuditLogs(currentPage);
    } else {
      fetchAuditSessions(sessionPage);
    }
  }, [viewMode, 
    currentPage, 
    sessionPage, 
    actionFilter, 
    actorTypeFilter, 
    modelFilter, 
    sessionIdFilter]);

  // Search
  const handleSearch = (query) => {
    setSearchQuery(query);

    if (!query.trim()) return setFilteredData(auditLogs);

    const lower = query.toLowerCase();

    const filtered = auditLogs.filter((log) =>
      log.model?.toLowerCase().includes(lower) ||
      log.action?.toLowerCase().includes(lower) ||
      log.actor?.name?.toLowerCase().includes(lower) ||
      log.actor?.type?.toLowerCase().includes(lower) ||
      log.meta?.apiEndpoint?.toLowerCase().includes(lower) ||
      log.meta?.frontendUrl?.toLowerCase().includes(lower) ||
      log.requestId?.toLowerCase().includes(lower)
    );

    setFilteredData(filtered);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  /*useEffect(() => {
    fetchAuditLogs(currentPage);
  }, [currentPage]);*/ //Fix a serious bug (double fetching logs)


  const page = viewMode === "LOGS" ? currentPage : sessionPage;
  const total = viewMode === "LOGS" ? totalPages : totalSessionPages;

  return (
    <div className="flex h-screen">
      <AdminSideMenu />

      <div className="flex-1 p-6 bg-gray-100 pt-16 flex flex-col">
        {/* Header */}
        <div className="flex gap-3 mb-4">
          
          <button
            onClick={() => setViewMode("SESSIONS")}
            className={`px-4 py-2 rounded ${
              viewMode === "SESSIONS" ? "bg-blue-600 text-white" : "bg-gray-300"
            }`}
          >
            Login Sessions
          </button>
          
          <button
            onClick={() => setViewMode("LOGS")}
            className={`px-4 py-2 rounded ${
              viewMode === "LOGS" ? "bg-blue-600 text-white" : "bg-gray-300"
            }`}
          >
            Audit Logs
          </button>

        </div>

        {viewMode === "LOGS" && (
        <>
          {/* Search */}
          <div className="flex justify-end mb-4">
            <input
              type="text"
              placeholder="Search logs..."
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              className="p-2 border rounded w-1/3"
            />
          </div>

          {/* Filters */}
          <div className="flex gap-3 mb-4 flex-wrap">
            {/* Action */}
            <select
                value={actionFilter}
                onChange={(e) => {
                setCurrentPage(1);
                setActionFilter(e.target.value);
                }}
                className="p-2 border rounded"
            >
                <option value="">All Actions</option>
                <option value="CREATE">CREATE</option>
                <option value="UPDATE">UPDATE</option>
                <option value="DELETE">DELETE</option>
            </select>

            {/* Actor Type */}
            <select
                value={actorTypeFilter}
                onChange={(e) => {
                setCurrentPage(1);
                setActorTypeFilter(e.target.value);
                }}
                className="p-2 border rounded"
            >
                <option value="">All Actors</option>
                <option value="ADMIN">ADMIN LOGIN</option>
                <option value="BUSINESS">BUSINESS LOGIN</option>
            </select>

            {/* Model */}
            <input
                type="text"
                placeholder="Filter by update area..."
                value={modelFilter}
                onChange={(e) => {
                setCurrentPage(1);
                setModelFilter(e.target.value);
                }}
                className="p-2 border rounded"
            />

            {/* Session ID */}
            <input
                type="text"
                placeholder="A single login sessions ID"
                value={sessionIdFilter}
                onChange={(e) => {
                setCurrentPage(1);
                setSessionIdFilter(e.target.value);
                }}
                className="p-2 border rounded"
            />

            {/* Clear Filters */}
            <button
                onClick={() => {
                setActionFilter("");
                setActorTypeFilter("");
                setModelFilter("");
                setSessionIdFilter("");
                setCurrentPage(1);
                }}
                className="px-3 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
            >
                Clear Filters
            </button>
          </div>
        </>
        )}

        {/* List */}
        {viewMode === "LOGS" ? (
          <div className="flex-1 overflow-auto space-y-4">
            {isLoading ? (
              <p className="text-center text-blue-600 py-4">Loading...</p>
            ) : error ? (
              <p className="text-center text-red-600 py-4">{error}</p>
            ) : filteredData.length === 0 ? (
              <p className="text-center py-4 text-gray-600">No logs found</p>
            ) : (
              filteredData.map((log) => (
                <div key={log._id} className="border rounded shadow bg-white">
                  {/* Header */}
                  <div
                    className="flex justify-between items-center p-4 bg-gray-200 cursor-pointer"
                    onClick={() =>
                      setExpandedLogId(expandedLogId === log._id ? null : log._id)
                    }
                  >
                    <div className="flex flex-col">
                      <span className="font-semibold">
                        {log.action} - {log.model}
                      </span>
                      <span className="text-sm text-gray-600">
                        Actor: {log.actor?.name} ({log.actor?.type})
                      </span>
                      <span className="text-xs text-gray-500">
                        {new Date(log.createdAt).toLocaleString()}
                      </span>
                    </div>

                    <span className="text-sm text-blue-600">
                      {expandedLogId === log._id ? "Hide Details" : "View Details"}
                    </span>
                  </div>

                  {/* Expanded Details */}
                  {expandedLogId === log._id && (
                    <div className="p-4 bg-gray-50 text-sm space-y-2">
                      <div>
                        <strong>Document ID:</strong> {log.documentId}
                      </div>

                      <div>
                        <strong>Request ID:</strong> {log.requestId || "-"}
                      </div>

                      <div>
                        <strong>API Endpoint:</strong> {log.meta?.apiEndpoint}
                      </div>

                      <div>
                        <strong>Frontend URL:</strong> {log.meta?.frontendUrl}
                      </div>

                      <div>
                        <strong>Method:</strong> {log.meta?.method}
                      </div>

                      {/*Make Session ID Clickable*/}
                      <div>
                          <strong>Session ID:</strong>{" "}
                          <span
                              className="text-blue-600 cursor-pointer underline"
                              onClick={() => {
                              setSessionIdFilter(log.meta?.sessionId);
                              setCurrentPage(1);
                              }}
                          >
                              {log.meta?.sessionId}
                          </span>
                      </div>

                      <div>
                        <strong>IP Address:</strong> {log.ipAddress}
                      </div>

                      {/* Changes */}
                      <div>
                        <strong>Changes:</strong>
                        <pre className="bg-black text-green-400 p-3 rounded mt-2 overflow-auto text-xs">
                          {JSON.stringify(log.changes, null, 2)}
                        </pre>
                      </div>
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
        ) : (
          <div className="flex-1 overflow-auto space-y-4">
            {sessions.map((s) => (
              <div key={s._id} className="border rounded shadow bg-white p-4">
                <div className="flex justify-between">
                  <div>
                    <div className="font-semibold">
                      {s.actor.name} ({s.actor.type})
                    </div>
                    <div className="text-sm text-gray-600">
                      {new Date(s.loginAt).toLocaleString()}
                    </div>
                    <div className="text-xs text-gray-500">
                      IP: {s.ipAddress} | {s.browser} | {s.os}
                    </div>
                    <div className={`text-xs font-semibold ${
                      !s.logoutAt ? "text-green-600" : "text-gray-500"
                    }`}>
                      {!s.logoutAt ? "ACTIVE SESSION" : `Logout: ${s.logoutReason}`}
                    </div>
                  </div>

                  <span
                    className="text-sm text-blue-600 cursor-pointer"
                    onClick={() => {
                      setSessionIdFilter(s.sessionId);
                      setViewMode("LOGS");
                      setCurrentPage(1);
                    }}
                  >
                    View Details
                  </span>
                </div>
              </div>
            ))
            } 
          </div>
      )}

        {/* Pagination */}
        
        <div className="flex justify-between items-center mt-4">
          <button
           onClick={() => {
              if (viewMode === "LOGS") handlePageChange(currentPage - 1);
              else setSessionPage((p) => Math.max(1, p - 1));
            }}
            disabled={currentPage === 1}
            className={`px-4 py-2 rounded ${
              currentPage === 1
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            Previous
          </button>

          <p className="text-sm">
            Page {page} of {total}
          </p>

          <button
            onClick={() => {
              if (viewMode === "LOGS") handlePageChange(currentPage + 1);
              else setSessionPage((p) => Math.max(1, p + 1));
            }}
            disabled={currentPage === totalPages}
            className={`px-4 py-2 rounded ${
              currentPage === totalPages
                ? "bg-gray-300 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};